// One source for what a resume upload accepts and how it is described, so the
// onboarding modal, the profile page and the re-upload button never drift.
// `accept` is only a picker hint: the server decides from the file's bytes.
export const RESUME_ACCEPT =
  ".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
export const RESUME_MAX_BYTES = 5 * 1024 * 1024;
export const RESUME_FORMAT_LINE = "PDF or Word (.docx), up to 5 MB";
export const RESUME_GOOGLE_DOC_LINE = "Have a Google Doc? Use File → Download → PDF.";
